var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  background-color: ', ';\n  padding: 1rem;\n  padding-bottom: 0;\n  margin-top: 1.5rem;\n  z-index: 9999;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: ', ';\n    max-width: ', 'px;\n    margin: 0 auto;\n    padding: 2.5rem 0 0.5rem 0;\n    font-size: 1.25rem !important;\n\n    &:after {\n      display: block;\n      content: \'\';\n      border-top: solid 1px ', ';\n      border-bottom: solid 1px ', ';\n      margin-bottom: 1rem;\n    }\n  }\n\n  a:hover {\n    text-decoration: none !important;\n  }\n\n  .horizontal-buttons {\n    display: none;\n  }\n\n  @media screen and (max-width: 1024px) {\n    .horizontal-buttons {\n      display: block;\n      padding: 0;\n\n      ul {\n        margin: 0;\n      }\n    }\n  }\n\n  &.expanded {\n    position: absolute;\n    left: 0;\n    right: 0;\n    display: block;\n    padding-bottom: 8rem;\n  }\n\n  &.collapsed {\n    display: none;\n  }\n\n  .vertical-items {\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  li {\n    list-style: none;\n    margin: 0;\n    padding: 0 1.25rem;\n    margin-bottom: 1rem;\n\n    p,\n    a {\n      max-width: ', 'px;\n      color: ', ';\n      margin: 0 auto;\n      display: block;\n      padding: 0.25rem 0;\n\n      &:hover {\n        color: ', ';\n        font-weight: bold;\n      }\n\n      &:hover:before {\n        background-color: transparent;\n      }\n    }\n  }\n'], ['\n  width: 100%;\n  background-color: ', ';\n  padding: 1rem;\n  padding-bottom: 0;\n  margin-top: 1.5rem;\n  z-index: 9999;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: ', ';\n    max-width: ', 'px;\n    margin: 0 auto;\n    padding: 2.5rem 0 0.5rem 0;\n    font-size: 1.25rem !important;\n\n    &:after {\n      display: block;\n      content: \'\';\n      border-top: solid 1px ', ';\n      border-bottom: solid 1px ', ';\n      margin-bottom: 1rem;\n    }\n  }\n\n  a:hover {\n    text-decoration: none !important;\n  }\n\n  .horizontal-buttons {\n    display: none;\n  }\n\n  @media screen and (max-width: 1024px) {\n    .horizontal-buttons {\n      display: block;\n      padding: 0;\n\n      ul {\n        margin: 0;\n      }\n    }\n  }\n\n  &.expanded {\n    position: absolute;\n    left: 0;\n    right: 0;\n    display: block;\n    padding-bottom: 8rem;\n  }\n\n  &.collapsed {\n    display: none;\n  }\n\n  .vertical-items {\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  li {\n    list-style: none;\n    margin: 0;\n    padding: 0 1.25rem;\n    margin-bottom: 1rem;\n\n    p,\n    a {\n      max-width: ', 'px;\n      color: ', ';\n      margin: 0 auto;\n      display: block;\n      padding: 0.25rem 0;\n\n      &:hover {\n        color: ', ';\n        font-weight: bold;\n      }\n\n      &:hover:before {\n        background-color: transparent;\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow-x: auto;\n  height: calc(100vh - 90px);\n  max-width: ', 'px;\n  margin: 0 auto;\n'], ['\n  overflow-x: auto;\n  height: calc(100vh - 90px);\n  max-width: ', 'px;\n  margin: 0 auto;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  & ul > li,\n  & > li {\n    border-left: solid 5px transparent;\n    padding: 0 1.25rem;\n    margin-bottom: 0.5rem;\n    border-bottom: solid 1px transparent;\n    position: relative;\n\n    &:hover {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &::before {\n        content: \'\';\n        position: relative;\n        content: \'\';\n        display: inline-block;\n        width: 0.5em;\n        height: 0.5em;\n        border-right: 0.2em solid ', ';\n        border-top: 0.2em solid ', ';\n        transform: rotate(45deg) translateY(-50%);\n        margin-right: 0.5em;\n        position: absolute;\n        left: 0;\n        top: 50%;\n      }\n    }\n\n    &:nth-child(3n + 1) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n\n    &:nth-child(3n + 2) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n\n    &:nth-child(3n + 3) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n  }\n'], ['\n  & ul > li,\n  & > li {\n    border-left: solid 5px transparent;\n    padding: 0 1.25rem;\n    margin-bottom: 0.5rem;\n    border-bottom: solid 1px transparent;\n    position: relative;\n\n    &:hover {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &::before {\n        content: \'\';\n        position: relative;\n        content: \'\';\n        display: inline-block;\n        width: 0.5em;\n        height: 0.5em;\n        border-right: 0.2em solid ', ';\n        border-top: 0.2em solid ', ';\n        transform: rotate(45deg) translateY(-50%);\n        margin-right: 0.5em;\n        position: absolute;\n        left: 0;\n        top: 50%;\n      }\n    }\n\n    &:nth-child(3n + 1) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n\n    &:nth-child(3n + 2) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n\n    &:nth-child(3n + 3) {\n      border-color: ', ';\n      border-bottom-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Constants from '../../../../themes/rml';
import Button, { GhostButton } from '../../../StyledComponents/Button';
import { getDefaultMenuItems } from '../HorizontalMenuItems';
var Container = styled.nav(_templateObject, Constants.colours.darkest, Constants.colours.light, Constants.ui.containerWidth, Constants.colours.dark, Constants.colours.darkest, Constants.ui.containerWidth, Constants.colours.light, Constants.colours.lightest);
var Wrapper = styled.div(_templateObject2, Constants.ui.containerWidth);
var Items = styled.div(_templateObject3, Constants.colours.lightest, Constants.colours.neutral.base, Constants.colours.lightest, Constants.colours.lightest, Constants.colours.tertiary.base, Constants.colours.neutral.darkest, Constants.colours.tertiary.base, Constants.colours.secondary.base, Constants.colours.neutral.darkest, Constants.colours.secondary.base, Constants.colours.primary.base, Constants.colours.neutral.darkest, Constants.colours.primary.base);

var isButtonType = function isButtonType(itemType) {
  switch (itemType) {
    case React.createElement(Button, null).type:
    case React.createElement(GhostButton, null).type:
      return true;

    default:
      return false;
  }
};

var isHeading = function isHeading(itemType) {
  return itemType.toString().startsWith('h');
};

var isRumComponent = function isRumComponent(item) {
  return item.props[':rum/initial-state'];
};

var getElementType = function getElementType(item) {
  if (!item || Array.isArray(item) && item.length === 0) return 'none';

  if (isHeading(item.type)) {
    return 'heading';
  }

  if (isButtonType(item.props && item.props.children && item.props.children.type)) {
    return 'button';
  }

  if (isRumComponent(item)) {
    return 'rum-component';
  }

  return item.type;
};

var isValidMenu = function isValidMenu(menu) {
  return menu && menu.title && menu.links && menu.links.length > 0;
};

var generateMenuItemsFromLinks = function generateMenuItemsFromLinks(menu, index) {
  if (!isValidMenu(menu)) return React.createElement(React.Fragment, null);
  return React.createElement('div', {
    key: index
  }, React.createElement('h2', null, menu.title), React.createElement('ul', null, (menu.links || []).map(function (item, index) {
    return Array.isArray(item) ? generateMenuItemsFromLinks(item, index) : generateMenuItemsFromElement(item, index);
  })));
};

var generateMenuItemsFromElement = function generateMenuItemsFromElement(item, index) {
  var elementType = getElementType(item);

  switch (elementType) {
    case 'none':
      return React.createElement(React.Fragment, null);

    case 'rum-component':
    case 'heading':
      return item;

    case 'button':
      return item.props.children;

    case 'ul':
      return item.props.children.map(function (item, index) {
        return React.createElement('li', {
          key: index
        }, item.props.children);
      });

    case 'li':
      return React.createElement('li', {
        key: index
      }, item.props.children);

    case 'a':
      return React.createElement('li', {
        key: index
      }, item);

    default:
      return React.createElement('div', {
        key: index
      }, item);
  }
};

var generateFromLinkGroups = function generateFromLinkGroups(linkGroups) {
  return linkGroups.map(function (item, index) {
    return generateMenuItemsFromLinks(item, index);
  });
};

var generateMenuItems = function generateMenuItems(items) {
  if (!items) return React.createElement(React.Fragment, null);

  if (Array.isArray(items)) {
    return items.map(function (item, index) {
      if (item.title && item.links) {
        return generateMenuItemsFromLinks(item, index);
      }

      return generateMenuItemsFromElement(item, index);
    });
  }

  var linkGroups = items.props && items.props.linkGroups;

  if (Array.isArray(linkGroups)) {
    return generateFromLinkGroups(linkGroups);
  }

  var buttons = items.props && items.props.buttons;

  if (Array.isArray(buttons)) {
    return buttons.map(function (item, index) {
      return generateMenuItemsFromElement(item, index);
    });
  }

  return items;
};

var getButtons = function getButtons(_ref) {
  var buttons = _ref.buttons,
      groupDomain = _ref.groupDomain,
      websiteDomain = _ref.websiteDomain;
  if (buttons) return generateMenuItems(buttons);
  var defaultMenuItems = getDefaultMenuItems({
    groupDomain: groupDomain,
    websiteDomain: websiteDomain
  });
  return React.createElement(React.Fragment, null, React.createElement('h2', null, 'Quick links'), generateMenuItems(defaultMenuItems));
};

var VerticalMenuItems = function VerticalMenuItems(_ref2) {
  var toggle = _ref2.toggle,
      menuItems = _ref2.menuItems,
      buttons = _ref2.buttons,
      websiteDomain = _ref2.websiteDomain,
      groupDomain = _ref2.groupDomain,
      _ref2$pivotHorizontal = _ref2.pivotHorizontalButtons,
      pivotHorizontalButtons = _ref2$pivotHorizontal === undefined ? true : _ref2$pivotHorizontal,
      _ref2$expanded = _ref2.expanded,
      expanded = _ref2$expanded === undefined ? false : _ref2$expanded;
  return React.createElement(Container, {
    className: expanded ? 'expanded' : 'collapsed',
    onClick: function onClick() {
      return toggle();
    }
  }, React.createElement(Wrapper, null, React.createElement(Items, {
    className: 'vertical-items'
  }, generateMenuItems(menuItems)), pivotHorizontalButtons && React.createElement(Items, {
    className: 'horizontal-buttons'
  }, getButtons({
    buttons: buttons,
    groupDomain: groupDomain,
    websiteDomain: websiteDomain
  }))));
};

export default withTheme(VerticalMenuItems);